import type {
  EmbeddedItemType,
  IngredientGroupType,
  ItemType,
  ItemWithIngredientsType,
} from "@/types/item";
import axios from "axios";

const toItem = async (embeddedItem: EmbeddedItemType): Promise<ItemType> => {
  const response = await axios.get(
    `https://kaman.rest/api/item-details?item_id=${embeddedItem.id}`
  );

  const item = response.data.data.item;

  return {
    id: item.id,
    name: item.name,
    description: item.description,
    price: item.price,
    image: item.image,
    companyName: item.company.name,
    companyId: item.company.id,
    categoryName: item.category.name,
  };
};

const rawIngredientsToIngredientGroups = (rawIngredients: any) => {
  const ingredientGroups: IngredientGroupType[] = [];

  Object.entries(rawIngredients).forEach(([key, value]: [any, any]) => {
    const ingredients = value.map((ingredient: any) => {
      return {
        id: ingredient.id,
        name: ingredient.name,
        price: ingredient.price,
        image: ingredient.image,
        isDefault: ingredient.default_ingredient === 1,
      };
    });

    const ingredientGroup: IngredientGroupType = {
      name: key,
      isMulti: value[0].category_type === "multi_option",
      ingredients,
    };

    ingredientGroups.push(ingredientGroup);
  });

  return ingredientGroups;
};

const withIngredients = async (
  item: ItemType
): Promise<ItemWithIngredientsType> => {
  const response = await axios.get(
    `https://kaman.rest/api/item-details?item_id=${item.id}`
  );

  const rawIngredient = response.data.data.item_ingredients;

  const ingredientGroups: IngredientGroupType[] = [];

  Object.entries(rawIngredient).forEach(([key, value]: [any, any]) => {
    const ingredients = value.map((ingredient: any) => {
      return {
        id: ingredient.id,
        name: ingredient.name,
        price: ingredient.price,
        image: ingredient.image,
        isDefault: ingredient.default_ingredient === 1,
      };
    });

    const ingredientGroup: IngredientGroupType = {
      name: key,
      isMulti: value[0].category_type === "multi_option",
      ingredients,
    };

    ingredientGroups.push(ingredientGroup);
  });

  const itemWithIngredients: ItemWithIngredientsType = {
    ...item,
    ingredientGroups: ingredientGroups,
  };

  return itemWithIngredients;
};

export { withIngredients, toItem, rawIngredientsToIngredientGroups };
